import BaseError from "./BaseError";

export default class HTTPVersionNotSupportedError extends BaseError {
  constructor(data) {
    super(data);
    this.name = "HTTPVersionNotSupportedError";
  }
}
